import {
  SIZE_CHOICES, COLOR_CHOICES, MDCButtonComponent
} from './button.component';

class NavButtonComponent extends MDCButtonComponent {
  constructor($element) {
    'ngInject';

    super($element);
    this.size = SIZE_CHOICES.MINIMAL;

    this.light = false;
    this.error = false;
    this.isDisabled = false;
  }

  getButtonColor() {
    if (this.error && this.light) {
      return COLOR_CHOICES.WHITERED
    }
    return (this.light? COLOR_CHOICES.WHITEGREEN : COLOR_CHOICES.GREEN);
  }
}

const config = MDCButtonComponent.componentConfig(NavButtonComponent);

const mod = angular.module('common.materialComponents.navButton', [
])

.component('navButton', config);

export default mod.name;
